import { useEffect } from 'react';
import { applySeo, type SeoData } from '@/lib/seo';

export function useSeo(data: SeoData): void {
  const serialized = JSON.stringify(data);
  useEffect(() => {
    applySeo(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serialized]);
}